// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3flzl","footer":"ReportModalFilter_footer__32qlI"};